// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"202":"7de8e23c","506":"a356a662","594":"31e013ea","720":"1f0b4cc4"}[chunkId] + ".js";
};